// extracted by mini-css-extract-plugin
module.exports = {"navibar":"style-navibar-2CxAd","navibarItem":"style-navibarItem-L4fsP","navibarItemLight":"style-navibarItemLight-TPm62"};